<router-outlet></router-outlet>
<p-toast position="top-left"></p-toast>
<!--<app-image-editor></app-image-editor>-->